import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {LogementService} from "../../services/logement.service";
import {ContactService} from "../../services/contact.service";
import {faPlus, faRetweet} from '@fortawesome/free-solid-svg-icons';
import {NgbDate, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Logement} from "../../models/logement";
import {UserService} from "../../services/user.service";
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {ConsumptionService} from "../../services/consumption.service";
import { addDays, isValid, parseISO } from 'date-fns';
import {Consumption} from "../../models/consumption";
import {AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {User} from "../../models/user";
import {environment} from "../../../environments/environment";
import {EnergieEnum} from "../rt2012/suivi-des-consommations/enums/EnergieEnum";
import {EnergieService} from "../../services/rt2012/energie.service";

@Component({
    selector: 'app-consumption',
    templateUrl: './consumption.component.html',
    styleUrls: ['./consumption.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsumptionComponent implements OnInit {
  startDateModelFirstPeriod: NgbDateStruct;
  endDateModelFirstPeriod: NgbDateStruct;
  startDateModelSecondPeriod: NgbDateStruct;
  faPlus = faPlus;
  faReload = faRetweet;
  logement$: Observable<Logement> = null;
  logementId: number = null;
  consumption: Observable<Consumption> = null;
  consumptionData: Consumption = null;
  private consumptionSubscription: Subscription = null;
  searchForm: UntypedFormGroup;c
  startDateFirstPeriod: Date;
  endDateFirstPeriod: Date;
  startDateSecondPeriod: Date;
  state = 'default';
  private readonly BREAKPOINT = 992;
  private logementSubscription: Subscription = null;
  hasEnedisAccessToken: boolean;
  hasGazparAccessToken: boolean;
  loadingTerminate: boolean;
  logement: Logement;
  user: User;
  showNavBar = true;
  selectedEnergie = null;
  energiesAvailables: EnergieEnum[] = [];
  energiesEditables: EnergieEnum[] = [];
  EnergieEnum = EnergieEnum;
  changed  = false;

  constructor(private router: Router,
              private logementService: LogementService,
              public modalService: NgbModal,
              public userService: UserService,
              private energieService: EnergieService,
              private consumptionService: ConsumptionService) {
  }

  ngOnInit() {
    this.onResize();
    this.logementSubscription = this.logementService.logementCourant.subscribe(l => {
      this.logement = l;
      this.reloadRelevesEtConsos();
    });

    this.searchForm = new UntypedFormGroup({
      startDateModelFirstPeriod: new UntypedFormControl(null, [
        Validators.required,
        this.correctDateValidator(),
      ]),
      endDateModelFirstPeriod: new UntypedFormControl(null, [
        Validators.required,
        this.correctDateValidator(),
      ]),
      startDateModelSecondPeriod: new UntypedFormControl(null, [
        Validators.required,
        this.correctDateValidator(),
      ]),
    });
    this.energiesAvailables = this.energieService.getEnergiesAvailables(this.logement);
    this.energiesEditables = this.energieService.getEnergiesEditables(this.logement);
    this.consumption = this.consumptionService.consumptions;
    this.logement$ = this.logementService.logementCourant;
    this.logementId = this.logementService.getLogementCourantId();
    this.initPeriode();
  }

  initPeriode(): void {
    // moment mutait `today` d'un appel à l'autre : les décalages se cumulaient
    // (-31, puis -32, puis -62 jours). date-fns étant immutable, on repart de
    // `today` à chaque fois avec le décalage total.
    const today = new Date();
    this.startDateSecondPeriod = addDays(today, -31);
    this.endDateFirstPeriod = addDays(today, -32);
    this.startDateFirstPeriod = addDays(today, -62);

    this.searchForm.setValue({
      'startDateModelFirstPeriod':this.startDateFirstPeriod.toISOString().slice(0, 10),
      'endDateModelFirstPeriod':this.endDateFirstPeriod.toISOString().slice(0, 10),
      'startDateModelSecondPeriod':this.startDateSecondPeriod.toISOString().slice(0, 10),
    })
    this.reloadSearch();
  }

  reloadSearch(): Promise<void> {
    if(this.searchForm.valid) {
      return new Promise(resolve => {
        this.changed = false;

        this.consumptionSubscription = this.consumptionService.search(
          this.logementId,
          this.searchForm.value.startDateModelFirstPeriod,
          this.searchForm.value.endDateModelFirstPeriod,
          this.searchForm.value.startDateModelSecondPeriod,
          this.selectedEnergie
        )
          .subscribe(consumption => {
            this.consumptionData = consumption;
            resolve();
          });
      });
    }
  }

  // Les champs sont des <input type="date"> : leur valeur est une chaîne
  // « yyyy-MM-dd ». On accepte aussi un Date, comme le faisait moment, pour
  // couvrir une alimentation programmatique du formulaire.
  private static toDate(value: any): Date {
    return value instanceof Date ? value : parseISO(String(value));
  }

  correctDateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value === null || !isValid(ConsumptionComponent.toDate(control.value))) {
        return {
          correctDate: {
            value: control.value,
            reason: 'Le format de la date doit être sous la forme jj/mm/aaaa.'
          }
        };
      } else{
        return null;
      }
    };
  }
  reloadUser() {
    return new Promise<void>(resolve => {
      this.userService.load().then(data => {
        this.user = data;
        this.hasEnedisAccessToken = this.checkEnedisAccessToken(this.user, this.logement);
        this.hasGazparAccessToken = this.checkGazparAccessToken(this.user, this.logement);
        resolve();
      });
    });
  }

  public checkEnedisAccessToken(user: any, logement: any) {
    return user && user.enedisAccessTokens.filter(enedisAccessToken => enedisAccessToken.logement.id === logement.id).length > 0;
  }

  public checkGazparAccessToken(user: any, logement: any) {
    return user && user.gazparAccessTokens.filter(gazparAccessToken => gazparAccessToken.logement.id === logement.id).length > 0;
  }

  async reloadRelevesEtConsos() {
    await this.reloadUser();
    this.loadingTerminate = true;
  }

  getFromLinky() {
    window.location.href = environment.rt2012.enedis.enedisConsentUrl + '?logement_id=' + this.logement.id;
  }

  onResize() {
    this.showNavBar = (document.body.clientWidth > this.BREAKPOINT);
  }

  public getFromGazpar() {
    window.location.href = environment.rt2012.grdf.grdfConsentUrl + '?logement_id=' + this.logement.id;
  }

  updateSelectedEnergie(newValue) {
    this.changeStatus();
    this.selectedEnergie = newValue;
  }

  changeStatus(){
    this.changed = true;
  }
}
